module.exports = __webpack_public_path__ + "img/kiss-pink.bfafd37c.svg";